import { UploadItemCard } from '@app/modules/social-export/publish';
import { FragmentSocialUploadItemDto } from '@app/modules/fragments/fragment.types';
import { useFragment } from '../../hooks/useFragment';
import { useFragmentVideoEditionsEditsQuery } from '../../hooks/useFragmentVideoEditionsEditsQuery';
import { isFragmentSocialUploadWaitingForMedia } from './is-fragment-social-upload-waiting-for-media';
import { useSocialExportUploadItemCardActions } from './useSocialExportUploadItemCardActions';

interface SocialExportUploadItemCardProps {
  upload: FragmentSocialUploadItemDto;
}

/**
 * Fragment social upload card: delegates layout to shared social-export card.
 * Marks WAITING uploads as waiting-for-media while fragment assets or edit render media are not ready.
 */
export function SocialExportUploadItemCard({ upload }: SocialExportUploadItemCardProps) {
  const { fragment } = useFragment();
  const editsQuery = useFragmentVideoEditionsEditsQuery(fragment.id);
  const { trigger: actionsTrigger, menuAndDialog: actionsMenuAndDialog } =
    useSocialExportUploadItemCardActions({ upload });

  const waitingForMedia = isFragmentSocialUploadWaitingForMedia(
    upload,
    fragment.mediaCompletedAt,
    editsQuery.data,
  );

  return (
    <UploadItemCard
      upload={upload}
      actionsTrigger={actionsTrigger}
      actionsMenuAndDialog={actionsMenuAndDialog}
      waitingForMedia={waitingForMedia}
    />
  );
}
